import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
// mock
import { API_URL } from '../../api';
import showLoader from 'src/components/loader';
export const DeleteModal = ({ deleteModal, handleDeleteModal, deleteId, setTesti, setPlus, plus }) => {
  // ** Function to delete single FAQ
  const deleteFaq = async (id) => {
    showLoader(true);
    await axios
      .delete(`${API_URL}/api/FAQ/${id}`, {
        headers: {
          Authorization: cookies.get('TOKEN'),
        },
      })
      .then(
        (res) => {
          toast.success(res.data?.message || 'Data deleted successfully.');
          setPlus(plus + 1);
        },
        axios
          .get(`${API_URL}/api/FAQ`)
          .then((res) => {
            handleDeleteModal();
            setTesti(res?.data);
          })
          .catch((error) => {
            console.log(error);
            handleDeleteModal();
            toast.error(err?.response?.data?.message || 'Something went wrong');
          })
      );
    showLoader(false);
  };

  return (
    <Dialog open={deleteModal}>
      <DialogTitle>Delete FAQ</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1">Are you sure? </Typography>
        <Typography variant="subtitle1">Once deleted data cannot be recovered.</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={() => {
            deleteFaq(deleteId);
          }}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={handleDeleteModal}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
